import { Link } from "react-router-dom";
import { img } from "../../lib/api";

export const Logo = ({
  scrolled = false,
  variant,
  gradientSrc = "/brand/name.webp",
  whiteSrc = "/brand/name_white.webp",
  onClick,
  className = "",
}) => {
  const isWhite = variant === "white" || (variant === undefined && scrolled);
  const src = img(isWhite ? whiteSrc : gradientSrc);
  const size = scrolled ? "h-6 md:h-7" : "h-10 md:h-12";
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="logo-home-link"
      className={`inline-flex items-center transition-opacity duration-300 hover:opacity-80 ${className}`}
    >
      <img src={src} alt="KORIO — The core of every experience" className={`w-auto transition-[height] duration-300 ease-out ${size}`} />
    </Link>
  );
};
